import { AdminMe } from '@core/domains/adminMe/admin-me';
import { AdminMeStoreService } from '@core/domains/adminMe/adminMe-store.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { mergeMap } from 'rxjs/internal/operators/mergeMap';
import { filter } from 'rxjs/internal/operators/filter';
import { merge } from 'rxjs';

@Injectable()
export class ProductGuardService  {

  constructor(
    private router: Router,
    private adminStore: AdminMeStoreService,
  ) { }

  canActivateChild(snapshot: ActivatedRouteSnapshot): Observable<boolean|UrlTree> {
    const modules: string[] = (snapshot.data['products'] ?? []) as string[];
    const me = this.adminStore.adminMe ?? this.adminStore.initAdmin();
    const $admin = of(me);

    const $withLicence = $admin.pipe(
      filter((me: AdminMe) => me.products.length > 0),
      mergeMap((me: AdminMe) => me.products.some((val: string) => modules.includes(val)) ? of(true) : of(this.router.parseUrl(me.defaultModulePath)))
    );
    const $withoutLicence = $admin.pipe(
      filter((me: AdminMe) => me.products.length === 0),
      mergeMap((me: AdminMe) => of(this.router.parseUrl(me.defaultModulePath)))
    )

    return modules.length > 0 ? merge($withLicence, $withoutLicence) : of(true);
  }
}
